import {OnChanges, IChangeIndication} from '../../common.types';

export default class PaginationControlsController {
    static $inject = ['$timeout'];

    private currentPage: number;
    private pageCount : number;
    private count: number;
    private pageSize: number;

    onPageChange: (callbackArgs: {
        page: number
    }) => void;

    constructor (private $timeout: ng.ITimeoutService) {
        this.setPageCount();
    }

    $onChanges(changesObject: IChangeIndication) {
        if(changesObject['count'] || changesObject['pageSize']) {
            this.setPageCount();
        }
    };

    onNextPageClick() {
        this.currentPage ++;
        this.triggerOnChangeEvent();
    };

    onPrevPageClick() {
        this.currentPage --;
        this.triggerOnChangeEvent();
    }

    onFirstPageClick() {
        this.currentPage = 1;
        this.triggerOnChangeEvent();
    };

    onLastPageClick() {
        this.currentPage = this.pageCount;
        this.triggerOnChangeEvent();
    };

    setPageCount() {
        this.pageCount = Math.ceil(this.count / this.pageSize);
    }

    triggerOnChangeEvent () {
        // triggered inside $timeout to put it in next digest cycle
        // if triggered in the same digest cycle the parent component's two-way bind variables will not be updated in time
        this.$timeout(() => {
            this.onPageChange({page: this.currentPage});
        });
    }

}







/** WEBPACK FOOTER **
 ** ./app/common/components/paginationControls/paginationControls.controller.ts
 **/